<template>
  <div class="hello">
    <component ref="selectComponent" v-bind:is="componentName"></component> 
  </div>
</template>

<script>
import eventEditor from './eventEditor'//创建会议
import budgetEditor from './budgetEditor'//添加预算
import allocationEditor from './allocationEditor'//费用分摊
import attenderEditor from './attenderEditor'//参会人
import sessionEditor from './sessionEditor'//日程
import { iStorage } from 'smart-core-util'
export default {
  name: 'entry',
  data () {
    return {
//    componentName:'sessionEditor'
    }
  },
  mounted:function(){
    this.componentName = iStorage.get('componentName');
  },
  watch:{
    'componentName':function(newVal,oldVal){
      // console.log(newVal);
    }
  },
  components:{
    eventEditor,
    budgetEditor,
    allocationEditor,
    attenderEditor,
    sessionEditor
  },
  methods:{

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/entry.vue